import { Scroller, ScrollerProvider } from '@graphcommerce/framer-scroller'
import { ProductListLink, ProductListParams } from '@graphcommerce/magento-product'
import { extendableComponent } from '@graphcommerce/next-ui'
import { Box, Grid, SxProps, Theme, Typography } from '@mui/material'
import React from 'react'

const name = 'CategoryChildren' as const
const parts = ['container', 'scroller', 'link'] as const
const { classes } = extendableComponent(name, parts)

export function CustomCategoryChildren(props) {
  const { children, params, sx = [] } = props

  if (!children || children.length === 0) return null

  return (
    <ScrollerProvider scrollSnapAlign='none'>
      <Box
        className={classes.container}
        sx={[
          (theme) => ({
            display: 'flex',
            justifyContent: 'center',
            marginBottom: theme.spacings.sm,
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Grid className={classes.scroller} container gap={1} justifyContent='center'>
          {children.map((cat) => {
            if (!cat?.url_path || !cat.name || !cat.include_in_menu) return null

            return (
              <ProductListLink
                key={cat.url_path}
                underline='none'
                color='inherit'
                url={cat.url_path}
                filters={{ category_uid: { eq: cat.uid } }}
                sort={params.sort}
                className={classes.link}
                sx={(theme) => ({
                  whiteSpace: 'nowrap',
                  display: 'inline',
                  marginRight: `${theme.spacings.xxs}`,
                  marginLeft: `${theme.spacings.xxs}`,
                  typography: 'h6',
                  position: 'relative',
                  paddingY: '0.3rem',
                  paddingX: '0.8rem',
                  borderRadius: '2rem',
                  border: `1px solid transparent`,
                  boxShadow:
                    '0px 0px 1.5px hsl(0deg 0% 0% / 0.15), 0px 0.5px 0.6px hsl(0deg 0% 0% / 0.04), 0px 2.3px 2.9px -0.7px hsl(0deg 0% 0% / 0.06), 0px 7.6px 9.7px -1.5px hsl(0deg 0% 0% / 0.08)',

                  '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`,
                  },
                })}
              >
                {cat.name}
              </ProductListLink>
            )
          })}
        </Grid>
      </Box>
    </ScrollerProvider>
  )
}
